<template>
  <div>
    <CallHelpTel />
  </div>
  <div>
    <Search @upateShowNews="searchByKeyword"></Search>
  </div>
  <template v-for="item in news.items" :key="item.id">
    <GrayBlock :article="item" :data="item" justify="News_page" />
  </template>

  <a-pagination
    v-model:current="news.pagination.current"
    v-model:total="news.pagination.total"
    v-model:pageSize="news.pagination.pageSize"
    @change="changePage"
    :style="{ fontSize: fontSize.p + 'em' }"
  />
</template>

<script>
import { ref, reactive, inject } from "vue";
import CallHelpTel from "../components/Home/CallHelpTel.vue";
import GrayBlock from "../components/ContentBlock.vue";
import Search from "../components/Search.vue";
import { message } from "ant-design-vue";
import { apiNews } from "@/api/api.js";
import { toArticleFormat } from "@/util/article";
import { useStore } from "vuex";

export default {
  components: {
    GrayBlock,
    Search,
    CallHelpTel,
  },
  setup() {
    let fontSize = inject("fontSize");

    const store = useStore();
    let keyword = ref("");
    keyword.value = store.getters["getSearchKeyword"];

    const searchByKeyword = (str) => {
      news.pagination.current = 1;
      keyword.value = str;
      fetchNews();
    };

    const news = reactive({
      items: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
      },
    });
    const fetchNews = async () => {
      try {
        store.dispatch("setSearchData", {
          keyword: keyword.value,
          page: news.pagination.current,
        });
        const {
          data: { newsDatas, currentPage, totalPage },
        } = await apiNews({
          keyword: keyword.value,
          page: news.pagination.current,
        });
        const newsItems = newsDatas.map((d) => toArticleFormat(d));

        news.items = newsItems;
        news.pagination.current = currentPage;
        news.pagination.total = totalPage * 10;
      } catch (error) {
        console.log(error);
        message.error("無法取得最新消息資料");
      }
    };
    news.pagination.current = store.getters["getSearchPage"];
    fetchNews();

    const changePage = (page, pageSize) => {
      news.pagination.pageSize = pageSize;
      news.pagination.current = page;
      fetchNews();
    };

    return { news, changePage, fetchNews, searchByKeyword, fontSize };
  },
};
</script>
